import React from "react";
import Subject from "./Components/Subject";

const SubjectIndex: React.FC = () => {

  return <Subject />;
};
export default SubjectIndex;
